import { useState, useLayoutEffect, useCallback, useEffect } from 'react';
import { useAppLayoutContext } from '../internal/context/app-layout-context';
import { useMobile } from '../internal/hooks/use-mobile';
import { supportsStickyPosition } from '../internal/utils/dom';
import { getOverflowParents } from '../internal/utils/scrollable-containers';
import styles from './styles.css.js';
// Thickness of the root container border-top
export var CONTAINER_ROOT_BORDER = 1;
export var useStickyHeader = function (rootRef, headerRef, __stickyHeader, __stickyOffset) {
    // Having no overflow parents, means that the component uses body scroll.
    // In that case, we reach into AppLayoutContext in case sticky header needs to be
    //  offset down by the height of other sticky elements positioned on top of the view.
    var _a = useState(false), usesBodyScroll = _a[0], setState = _a[1];
    useLayoutEffect(function () {
        var overflowParents = rootRef.current && getOverflowParents(rootRef.current).length;
        setState(!overflowParents);
    }, [rootRef]);
    var stickyOffsetTop = useAppLayoutContext().stickyOffsetTop;
    var isMobile = useMobile();
    __stickyOffset = __stickyOffset || (usesBodyScroll ? stickyOffsetTop : undefined);
    var isSticky = supportsStickyPosition() && !isMobile && __stickyHeader;
    var stickyStyles = isSticky && __stickyOffset !== undefined
        ? {
            style: {
                top: __stickyOffset - CONTAINER_ROOT_BORDER + "px"
            }
        }
        : {};
    // "stuck" state, when the header has moved from its original posititon has a
    // box-shadow, applied here by a "header-stuck" className
    var checkIfStuck = useCallback(function () {
        if (rootRef.current && headerRef.current) {
            var rootTop = rootRef.current.getBoundingClientRect().top;
            var headerTop = headerRef.current.getBoundingClientRect().top;
            if (rootTop + CONTAINER_ROOT_BORDER < headerTop) {
                headerRef.current.classList.add(styles['header-stuck']);
            }
            else {
                headerRef.current.classList.remove(styles['header-stuck']);
            }
        }
    }, [rootRef, headerRef]);
    useEffect(function () {
        if (isSticky) {
            window.addEventListener('scroll', checkIfStuck, true);
            window.addEventListener('resize', checkIfStuck);
            return function () {
                window.removeEventListener('scroll', checkIfStuck, true);
                window.removeEventListener('resize', checkIfStuck);
            };
        }
    }, [isSticky, checkIfStuck]);
    return {
        isSticky: isSticky,
        stickyStyles: stickyStyles
    };
};
//# sourceMappingURL=use-sticky-header.js.map